import { watch, type Ref } from 'vue'
import { MathUtils } from '@previo/core'

type UsePriceInputModelOptions = {
  model: Ref<number | null>
  displayedValue: Ref<number | null>
  precision: Ref<number>
  setDisplayedValue: (value: number | null) => void
  onChange: (value: number | null) => void
}

export type UsePriceInputModelReturn = {
  onFocus: () => void
  onBlur: () => void
}

export const roundToPrecision = (value: number | null, precision: number): number | null => {
  if (value === null) {
    return null
  }

  return MathUtils.roundToPrecision(value, precision)
}

export const isDisplayedValueOf = (
  model: number | null,
  displayedValue: number | null,
  precision: number,
): boolean => {
  return displayedValue === model || displayedValue === roundToPrecision(model, precision)
}

export const usePriceInputModel = ({
  model,
  displayedValue,
  precision,
  setDisplayedValue,
  onChange,
}: UsePriceInputModelOptions): UsePriceInputModelReturn => {
  let modelOnFocus: number | null = null

  watch(displayedValue, (value) => {
    if (!isDisplayedValueOf(model.value, value, precision.value)) {
      model.value = value
    }
  })

  watch(model, (value) => {
    setDisplayedValue(value)
  })

  const onFocus = (): void => {
    modelOnFocus = model.value
  }

  const onBlur = (): void => {
    if (model.value !== modelOnFocus) {
      onChange(model.value)
    }
  }

  return { onFocus, onBlur }
}
